import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { GroupUser } from '../../_types/group-user';
import { GroupUsersService } from '../../_services/groups-users.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { UsersService } from 'src/app/modules/users/_services/users.service';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';

@Component({
    selector: 'app-group-user',
    templateUrl: './group-user.component.html',
    styleUrls: ['./group-user.component.scss'],
    standalone: false
})
export class GroupUserComponent {
  public groupUserFormGroup!: RxFormGroup;

  public groupUser: GroupUser = new GroupUser();
  public users: any[] = [];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private groupUsersService: GroupUsersService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private usersService: UsersService
  ) {
    this.groupUserFormGroup = this.formBuilder.formGroup<GroupUser>(this.groupUser) as RxFormGroup;
  }

  ngOnInit(): void {
    this.groupUser.groupId = this.config.data.groupId;
    this.loadUsers();

    this.allowWrite = true;
    this.allowDelete = true;
  }


  async loadUsers() {
    let filters = {
      isWorker: new Filter(FilterOperation.equals, 'isWorker', "", false)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    }



    let response = await firstValueFrom(this.usersService.all(params));
    let existentUsers = this.config.data.existentUsers;

    this.users = response.data;
    this.users = this.users.filter((user: any) => {
      return !existentUsers.some((existentUser: any) => existentUser.user.id === user.id);
    });
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.groupUserFormGroup);

    if (valid) {
      this.groupUser = Object.assign(this.groupUser, this.groupUserFormGroup.value);

      await this.groupUsersService.save(this.groupUser).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Usuario asignado correctamente' });
          this.dynamicDialogRef.close();
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al asignar el usuario' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
}
